import { Translation } from '../foundation/Translation'
import { BlockContainer } from './BlockContainer'
import styles from './Loading.scss'
import { ModuleContainer } from './ModuleContainer'

/**
 * Component for display a loading to user
 */
export function Loading() {
	return <Translation id="component:loading" as="p" />
}

export function LoadingComponent() {
	return (
		<BlockContainer shadow className={styles.loadingContainer}>
			<Loading />
		</BlockContainer>
	)
}

/**
 * Component for display a loading for an entire module
 */
export function LoadingModule() {
	return (
		<ModuleContainer>
			<BlockContainer className={styles.loading}>
				<Loading />
			</BlockContainer>
		</ModuleContainer>
	)
}

/**
 * Component return null when a module is loading
 */
export function NullLoading() {
	return null
}
